import type { ApplicationDomain } from 'src/routes/types';
import type { RequestStatus } from '@skynet/data-ws-core';

export enum AuthCommands {
  authOK = 'authOK',
  authRequired = 'authRequired',
  NotConnected = 'NotConnected',
  Auth = 'Auth',
  Authorization = 'Authorization',
  '2FA' = '2FA',
  Login = 'Login',
  Logout = 'Logout', // used on actual logout from both WS and Dashboard
  Disconnect = 'Disconnect', // used when we leave WS domain or switch between WS domains
  // ResetPassword = 'ResetPassword',
}

export interface LoginDomainData {
  domain: ApplicationDomain;
  forceLogin?: boolean;
  slug?: string;
}

export interface LoginDomainPayload {
  accessToken: string;
  token?: string;
  loan?: number;
  retainer?: number;
}

export interface AuthState {
  error: null | {
    title: string;
    description?: string;
  };
  redirectUrl: string;
  resAuth?: RequestStatus; // deprecated
  res2FA?: RequestStatus; // deprecated

  // from auth response
  isAuthedMM: boolean; // true if authOK received from WS MM
  isAuthedES: boolean; // true if authOK received from WS ES
  tokenMM?: string;
  tokenES?: string;
  name?: string;
  email?: string;
  lastAccess?: string; // Friday, 17/02/2023
  accessLevel?: number; // enum?
  userId?: number;
  notConnected?: boolean;
  authDomain?: string; // domain wich user is authenticated
}

export interface JsonAuthSuccess {
  command: string;

  // success
  token: string;
  Name: string;
  lastAccess: string;
  accessLevel: number;
  userID: number;
}
